if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        // MAHA (VELOCIDAD-12, 2026-10-12): cierre inicial SIN animacion. Antes: this.open = false, que
        // anima height (theme.js animateAccordion) en los 4 acordeones del pie durante la carga, abajo
        // donde nadie lo ve. Mismo estado final que animateAccordion(false). Al tocar sigue animando.
        // DEUDA: footer.js es del tema Hyper; una actualizacion del tema pisa este cambio.
        if (!this.openDefault) {
          this.isOpen = false;
          this.removeAttribute('open');
          this.setAttribute('aria-expanded', 'false');
          if (this.contentElement.id) this.setAttribute('aria-controls', this.contentElement.id);
          this.parentElement.classList.remove('active');
        }
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}